import DayOne, { image as DayOneImg } from "./dayOne";
import DayTwo, { image as DayTwoImg } from "./dayTwo";
import DayThree, { image as DayThreeImg } from "./dayThree";
import { getUserData } from "../../../config/common";
var createDay = function (background, links) {
    return {
        background: background,
        userData: getUserData(),
        name: "Breakout",
        links: links
    };
};
var breakouts = [
    createDay(DayOneImg, DayOne),
    createDay(DayTwoImg, DayTwo),
    createDay(DayThreeImg, DayThree)
];
export default breakouts;
